import React from "react";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Products from "@/components/sections/Products";
import Services from "@/components/sections/Services";
import Clients from "@/components/sections/Clients";
import News from "@/components/sections/News";
import Vacancies from "@/components/sections/Vacancies";
import Contact from "@/components/sections/Contact";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <About />
        <Products />
        <Services />
        <Clients />
        <News />
        {/* <Vacancies /> */}
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
